import React, {useState, useEffect} from 'react';
import Card from 'react-bootstrap/Card';
import {Button, Form} from 'react-bootstrap';
import Table from 'react-bootstrap/Table';
import {PfImage} from '@profabric/react-components';
import Modal from 'react-bootstrap/Modal';
import Select from 'react-select';
import styled from 'styled-components';
import * as AuthService from '../../../services/auth';
import {toast} from 'react-toastify';

const site = [
  {label: 'IP1', value: '1'},
  {label: 'IP2', value: '2'},
  {label: 'IP3', value: '3'},
  {label: 'DAP', value: '4'}
];

const type = [
  {label: 'รถยืม', value: '3'},
  {label: 'รถยืมพร้อมคนขับ', value: '4'}
];

export default function TableRentalCar(props) {
  const [showMd, setShowMd] = useState(false);
  const [mode, setMode] = useState('');
  const [car, setCar] = useState(null);

  const handleMdNew = (mode, item) => {
    setShowMd(true);
    setCar(item);
    setMode(mode);
  };

  return (
    <div>
      <Modal show={showMd} size={'lg'} onHide={() => setShowMd(false)}>
        <Modal.Header closeButton>
          <Modal.Title>
            {mode === 'add' ? 'เพิ่มรถยืม EV' : 'แก้ไขรถยืม EV'}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <Form.Group className="mb-6 col-md-6">
              <Select
                menuPortalTarget={document.body}
                styles={{menuPortal: (base) => ({...base, zIndex: 9999})}}
                placeholder={'ประเภทรถ'}
                options={type}
                value={type.find((v) => v.value === (car ? car.typeid : '0'))}
                onChange={(v) => {
                  setCar((prevState) => ({
                    ...prevState,
                    typeid: v.value
                  }));
                }}
              />
            </Form.Group>
            <Form.Group className="mb-6 col-md-6">
              <Select
                menuPortalTarget={document.body}
                styles={{menuPortal: (base) => ({...base, zIndex: 9999})}}
                placeholder={'สำนักงาน'}
                options={site}
                value={site.find((v) => v.value === (car ? car.siteid : '0'))}
                onChange={(v) => {
                  setCar((prevState) => ({
                    ...prevState,
                    siteid: v.value
                  }));
                }}
              />
            </Form.Group>
            <Form.Group className="mb-3 col-md-4">
              <Form.Label>#ID</Form.Label>
              <Form.Control
                disabled={true}
                type="text"
                value={car ? car.vehicleid : ''}
                placeholder="#ID"
              />
            </Form.Group>
            <Form.Group className="mb-3 col-md-4">
              <Form.Label>ชื่อเรียกรถ</Form.Label>
              <Form.Control
                type="text"
                placeholder="ชื่อเรียกรถ"
                value={car ? car.vehicleName : ''}
                onChange={(event) => {
                  setCar((prevState) => ({
                    ...prevState,
                    vehicleName: event.target.value
                  }));
                }}
              />
            </Form.Group>
            <Form.Group className="mb-3 col-md-4">
              <Form.Label>ชื่อย่อ</Form.Label>
              <Form.Control
                type="text"
                placeholder="ชื่อย่อ"
                value={car ? car.name : ''}
                onChange={(event) => {
                  setCar((prevState) => ({
                    ...prevState,
                    name: event.target.value
                  }));
                }}
              />
            </Form.Group>
            <Form.Group className="mb-3 col-md-4">
              <Form.Label>เลขทะเบียน</Form.Label>
              <Form.Control
                type="text"
                placeholder="เลขทะเบียน"
                value={car ? car.licensePlate : ''}
                onChange={(event) => {
                  setCar((prevState) => ({
                    ...prevState,
                    licensePlate: event.target.value
                  }));
                }}
              />
            </Form.Group>
            <Form.Group className="mb-3 col-md-4">
              <Form.Label>รหัสพนักงานคนขับรถ</Form.Label>
              <Form.Control
                type="text"
                placeholder="รหัสพนักงานคนขับรถ"
                value={car ? car.staffid : ''}
                onChange={(event) => {
                  setCar((prevState) => ({
                    ...prevState,
                    staffid: event.target.value
                  }));
                }}
              />
            </Form.Group>
          </div>
          <Button
            className={mode === 'add' ? 'ml-2' : 'd-none'}
            onClick={() => {
              props.onAdd(car);
              setShowMd(false);
            }}
          >
            เพิ่มข้อมูล
          </Button>
          <Button
            className={mode === 'edit' ? 'ml-2' : 'd-none'}
            onClick={() => {
              props.onUpdate(car);
              setShowMd(false);
            }}
          >
            แก้ไขข้อมูล
          </Button>
          <Button
            className={car && car.status && mode === 'edit' ? 'ml-2' : 'd-none'}
            variant="warning"
            onClick={() => {
              props.onUpdate({
                _id: car ? car._id : '',
                status: false
              });
              setShowMd(false);
            }}
          >
            ปิดการใช้งาน
          </Button>
          <Button
            className={car && !car.status && mode === 'edit' ? 'ml-2' : 'd-none'}
            variant="success"
            onClick={() => {
              props.onUpdate({
                _id: car ? car._id : '',
                status: true
              });
              setShowMd(false);
            }}
          >
            เปิดการใช้งาน
          </Button>
        </Modal.Body>
      </Modal>
      <Card className="card">
        <div className={props.show ? 'd-none' : 'overlay dark'}>
          <span style={{color: 'white', fontSize: 30}}>
            {props.title ? props.title : 'CR'} ONLY
          </span>
        </div>
        <Card.Header className="d-flex">
          <div className="mt-2">
            แสดงรายการรถยืม EV, กดปุ่มเพิ่มเพื่อเพิ่มรถคันใหม่
          </div>
          <div className="ml-auto row">
            <Button
              // disabled={true}
              variant="outline-primary"
              onClick={() => {
                handleMdNew('add', null);
              }}
            >
              + เพิ่มรถ EV
            </Button>
          </div>
        </Card.Header>
        <Table striped>
          <thead>
            <tr>
              <th className="d-none d-sm-table-cell">#</th>
              <th className="d-none d-sm-table-cell">ชื่อรถ</th>
              <th className="d-none d-sm-table-cell">ประเภทรถ</th>
              <th className="d-none d-lg-table-cell">คนขับรถ(ถ้ามี)</th>
              <th className="d-none d-lg-table-cell">เบอรโทรคนขับรถ(ถ้ามี)</th>
              <th className="d-none d-lg-table-cell">สถานะ</th>
              <th>ดู / แก้ไข</th>
            </tr>
          </thead>
          <tbody>
            {props.items ? (
              props.items.map((e, i) => {
                return (
                  <tr key={`group-${i}`}>
                    <td className="d-none d-sm-table-cell">{e.vehicleid}</td>
                    <td className="d-none d-sm-table-cell">{e.vehicleName}</td>
                    <td className="d-none d-sm-table-cell">{e.typeName}</td>
                    <td className="d-none d-lg-table-cell">{e.staffName}</td>
                    <td className="d-none d-lg-table-cell">{e.staffPhone}</td>
                    <td className="d-none d-lg-table-cell">
                      {e.status ? (
                        <input
                          type="button"
                          value="เปิดใช้งาน"
                          className="btn btn-outline-success btn-xs"
                        />
                      ) : (
                        <input
                          type="button"
                          value="ไม่เปิดใช้งาน"
                          className="btn btn-outline-danger btn-xs"
                        />
                      )}
                    </td>
                    <td>
                      <i
                        className="fas fa-search"
                        onClick={() => {
                          handleMdNew('edit', e);
                        }}
                      />
                    </td>
                  </tr>
                );
              })
            ) : (
              <></>
            )}
          </tbody>
        </Table>
      </Card>
    </div>
  );
}
